<template>
  <div class="check-content pa-0">
    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockscreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold">
            Aguarde, estamos processando os dados...
          </span>
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="colorCheckin"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <div class="check-background white content">
      <!--Header-->
      <v-card elevation="0" class="step-header">
        <v-btn text @click="backScreen()">
          <v-icon medium>mdi-chevron-left</v-icon>
        </v-btn>
      </v-card>

      <v-container class="register-content">
        <div class="title pb-1">
          Gostaria de abrir a porta utilizando o bluetooth do seu smartphone?
        </div>
        <div class="pb-2">
          Com isso você pode poupar tempo caso esteja tendo problemas com a
          maneira tradicional.
        </div>
        <div class="text-center">
          <v-icon color="var(--secondary-color)" style="font-size: 150px">
            bluetooth
          </v-icon>
        </div>

        <div class="text-center finish-button" v-if="!connected">
          <!--Finalizar-->
          <v-btn
            color="var(--secondary-color)"
            width="90%"
            class="white--text font-weight-bold"
            @click="acaoBluetooth"
          >
            {{
              this.deviceUsecar.length > 0
                ? 'CONECTAR BLUETOOTH'
                : 'PROCURAR BLUETOOTH'
            }}
          </v-btn>
          <v-btn
            color="var(--secondary-color)"
            width="90%"
            class="white--text font-weight-bold mt-3"
            @click="backScreen"
          >
            CANCELAR
          </v-btn>
        </div>
        <div class="text-center finish-button" v-else>
          <!--Finalizar-->
          <v-btn
            color="var(--secondary-color)"
            width="90%"
            class="white--text font-weight-bold"
            @click="abrirPortas"
          >
            ABRIR PORTAS
          </v-btn>
          <v-btn
            color="var(--secondary-color)"
            width="90%"
            class="white--text font-weight-bold mt-3"
            @click="fecharPortas"
          >
            FECHAR PORTAS
          </v-btn>
        </div>
      </v-container>
    </div>
  </div>
</template>
<script>
import VehicleController from '../../controllers/VehicleController';
export default {
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      blockscreen: false,
      devices: [],
      deviceUsecar: [],
      connected: false,
      vehicleId: this.$route.params.id,
      vehicle: {},
      vehicleController: new VehicleController(this.$resource),
    };
  },
  async created() {
    this.vehicle = await this.vehicleController.getVehicleByIdV2(
      this.vehicleId
    );
  },

  methods: {
    backScreen() {
      this.$router.push('/');
    },
    abrirPortas() {
      this.blockscreen = true;
      writeBluetooth(`${this.vehicle.bluetooth_mac_address}-01`);
      setTimeout(() => {
        this.snackbar = true;
        this.snackbarText = 'Comando enviado com sucesso!';
        this.snackbarColor = 'success';
        this.blockscreen = false;
      }, 3000);
    },
    fecharPortas() {
      this.blockscreen = true;
      writeBluetooth(`${this.vehicle.bluetooth_mac_address}-00`);
      setTimeout(() => {
        this.snackbar = true;
        this.snackbarText = 'Comando enviado com sucesso!';
        this.snackbarColor = 'success';
        this.blockscreen = false;
      }, 3000);
    },
    acaoBluetooth() {
      if (this.deviceUsecar.length > 0) {
        this.blockscreen = true;
        this.conectarBluetooth();
      } else {
        this.blockscreen = true;
        this.scanBluetooth();
      }
    },
    conectarBluetooth() {
      this.devices = [];
      connect((result) => {
        if (result.status === 'connected') {
          this.devices.push(result.status);
          this.discover();
        } else if (result.status === 'disconnected') {
          this.devices.push(result.status);
          this.blockscreen = false;
        }
      });
    },
    discover() {
      discover((result) => {
        this.devices.push(JSON.stringify(result));
        this.blockscreen = false;
        this.connected = true;
        this.snackbar = true;
        this.snackbarText = 'Dispositivo conectado!';
        this.snackbarColor = 'success';
      });
    },
    scanBluetooth() {
      scanBluetooth(this.vehicle.bluetooth_device_name);
      setTimeout(() => {
        stopScanBluetooth();
        this.devices = verifyBluetoothEncontrado();
        this.deviceUsecar = this.devices.filter((device) => {
          return device.name
            ? device.name == this.vehicle.bluetooth_device_name
            : false;
        });
        if (this.deviceUsecar.length > 0) {
          this.conectarBluetooth();
        } else {
          this.blockscreen = false;
          this.snackbar = true;
          this.snackbarText = 'Dispositivo não encontrado!';
          this.snackbarColor = 'error';
        }
      }, 5000);
    },
  },
};
</script>
<style scoped>
.finish-button {
  position: absolute;
  bottom: 15%;
  width: 90%;
}
.step-header {
  z-index: 3;
  /* position: fixed; */
  padding-top: 20px;
  font-size: 20px;
  font-weight: 700;
  height: 62px;
  width: 100%;
}
</style>
